import { Box, Button, Typography, useTheme } from '@mui/material';
import React from 'react';
import './ExpiredSignupPage.css';

interface ExpiredSignupPageProps {
  onReturnToLogin: () => void;
}

export const ExpiredSignupPage: React.FC<ExpiredSignupPageProps> = ({
  onReturnToLogin,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const logoSrc = isDark
    ? '/fmg-clips-logo-dark.svg'
    : '/fmg-clips-logo-light.svg';

  return (
    <Box
      className="expired-signup-page"
      sx={{
        backgroundColor: theme.palette.background.default,
      }}
    >
      {/* Main Content Container */}
      <Box className="expired-signup-page__content">
        {/* Logo */}
        <Box className="expired-signup-page__logo">
          <img src={logoSrc} alt="Feed Clips Logo" width="120" height="31" />
        </Box>
        {/* Title */}
        <Typography
          variant="h5"
          className="expired-signup-page__title"
          sx={{
            fontFamily: 'Space Grotesk',
            fontSize: '24px',
            fontWeight: 400,
            lineHeight: 1.334,
            color: theme.palette.text.primary,
            marginBottom: '12px',
          }}
        >
          This signup link has expired.
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body1"
          className="expired-signup-page__subtitle"
          sx={{
            fontFamily: 'Mulish',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: '0.15px',
            color: theme.palette.text.secondary,
            marginBottom: '32px',
          }}
        >
          Contact your system administrator for a new link.
        </Typography>

        {/* Return to Login Button */}
        <Button
          variant="contained"
          onClick={onReturnToLogin}
          className="expired-signup-page__button"
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          Return to Log In
        </Button>
      </Box>
    </Box>
  );
};
